import React, { useEffect, useState } from "react";
import { Button, PlusIcon } from "@pd/pd-ui-kit";
import { Flex } from "antd";
import { get } from "lodash";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";

import TrustedPersonsModal from "~/pages/Editor/EditorTrustedPersons/modals/TrustedPersonsModal";
import Wrapper from "~/shared/ui/Wrapper";
import { useGetLocationData, useSetLocationData } from "~/hooks/locationData";
import { TRUSTED_PERSONS_OPTIONS } from "~/pages/Editor/EditorTrustedPersons/utils/options";
import {
  TrustedPerson,
  useGetTrustedPersonsLazyQuery,
} from "~/schemas/generated/graphql";
import { usePermissions } from "~/shared/context/PermissionContext";
import { TableV2 } from "~/shared/ui/TableV2";

import { getEditorTrustedPersonsColumns } from "./model/tableAdapter";

import s from "./s.less";

const EditorTrustedPersons = () => {
  const { t } = useTranslation();
  const { hasPermission } = usePermissions();
  const { currentId } = useGetLocationData();
  const setData = useSetLocationData(true);
  const history = useHistory();
  const [persons, setPersons] = useState<TrustedPerson[]>([]);
  const goBack = () => history.replace("/editor/");

  const openAddModal = () => {
    setData("openModal", "Create");
  };
  const [getTrustedPersons, getTrustedPersonsState] =
    useGetTrustedPersonsLazyQuery({
      fetchPolicy: "no-cache",
    });
  const getTrustedPersonsHandler = () => {
    getTrustedPersons();
  };

  useEffect(() => {
    getTrustedPersonsHandler();
  }, []);

  useEffect(() => {
    if (getTrustedPersonsState.loading) getTrustedPersonsState.data = undefined;

    if (getTrustedPersonsState.data) {
      const requestData = get(
        getTrustedPersonsState.data,
        "TrustedPersonGetter.getTrustedPersons",
      );

      if (requestData) {
        setPersons(requestData);
      }
    }
  }, [getTrustedPersonsState.loading]);

  const currentPerson = persons.find((el) => el.id === currentId);

  const handleRowEdit = (record: TrustedPerson) => {
    setData("openModal", "Edit", "currentId", record.id);
  };

  return (
    <Wrapper.Content
      title={t("trustedPersons.title")}
      goBackHandler={goBack}
      txtBtn={t("ui.back")}
      controlComponent={
        <Flex gap={10}>
          {hasPermission("editor.contracts.trusted.create") && (
            <Button
              onClick={openAddModal}
              size={"middle"}
              icon={<PlusIcon size={16} />}
            >
              {t("trustedPersons.add")}
            </Button>
          )}
        </Flex>
      }
    >
      <TableV2<TrustedPerson>
        wrapperClassName={s.tableWrapper}
        columns={getEditorTrustedPersonsColumns(t, TRUSTED_PERSONS_OPTIONS)}
        dataSource={persons}
        loading={getTrustedPersonsState.loading}
        rowKey="id"
        onRowEdit={
          hasPermission("editor.contracts.trusted.edit")
            ? handleRowEdit
            : undefined
        }
      />

      <TrustedPersonsModal
        reFetch={getTrustedPersonsHandler}
        currentItem={currentPerson}
      />
    </Wrapper.Content>
  );
};

export default EditorTrustedPersons;
